
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neden-pembe-panjur",
      function () {
        return require("private-next-pages/neden-pembe-panjur.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neden-pembe-panjur"])
      });
    }
  